import React from 'react';
import EmailFieldProto from './email-proto';


export default function renderStringInView(id, props) {
    return <EmailFieldProto renderMode="view" id={id} {...props} />;
}